import React from "react";
import PropTypes from "prop-types";

const STATUS_CONFIG = {
    ORDER_ACTIVE:    { bg: "bg-blue-100",   text: "text-blue-700",   label: "Active"      },
    ORDER_PENDING:   { bg: "bg-yellow-100", text: "text-yellow-700", label: "Pending"     },
    ORDER_DELIVERED: { bg: "bg-green-100",  text: "text-green-700",  label: "Delivered"   },
    DELIVERED:       { bg: "bg-green-100",  text: "text-green-700",  label: "Delivered"   },
    PACKED:          { bg: "bg-orange-100", text: "text-orange-700", label: "Packed"      },
    DISPATCHED:      { bg: "bg-purple-100", text: "text-purple-700", label: "Dispatched"  },
    SHIPPED_IN_TRANSIT: { bg: "bg-indigo-100", text: "text-indigo-700", label: "In Transit" },
    CANCELLED:       { bg: "bg-red-100",    text: "text-red-700",    label: "Cancelled"   },
};

function StatusBadge({ status }) {
    const cfg = STATUS_CONFIG[status?.toUpperCase()] ?? {
        bg: "bg-gray-100", text: "text-gray-600", label: status ?? "—",
    };
    return (
        <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${cfg.bg} ${cfg.text}`}>
            {cfg.label}
        </span>
    );
}

StatusBadge.propTypes = { status: PropTypes.string };

export default StatusBadge;
